import React, { Component } from "react";
import { Tab } from "semantic-ui-react";
import FirstPageMatrix from "./FirstPageMatrix";
import SecondPageMatrix from "./SecondPageMatrix";

export class LiveListMatrix extends Component {
  render() {
    const panes = [
      {
        menuItem: { key: "page1", content: "Página 1 (0-129)" },
        render: () => <Tab.Pane> <FirstPageMatrix /> </Tab.Pane>
      },
      {
        menuItem: { key: "page2", content: "Página 2 (130-255)" },
        render: () => <Tab.Pane> <SecondPageMatrix/> </Tab.Pane>
      },
    ];

    return (
      <div style={divStyle}>
        <Tab panes={panes} renderActiveOnly={true} />
      </div>
    );
  }
}

const divStyle = {
  marginTop: "-0.5vh",
  marginLeft: "2vw",
  marginRight: "2vw",
  textAlign: "center"
};

export default LiveListMatrix;
